export const TG_ANCHORS_MESSAGE = (anchorsCounter: string) => {
    return  {
          header: "מגבלת עוגנים",
          text: `המערכת יכולה לשלוח עד 15,000 עוגנים. לקמפיין זה הוגדרו ${anchorsCounter} עוגנים, המערכת תחלק בצורה אוטו' את הקמפיין. האם להמשיך?`,
          showOkBtn: true,
          showCancelBtn: true,
          showCloseBtn: false
        }
 }

 export const FB_AVATARS_LIMIT =  {    
          header: "מגבלת אווטארים",
          text: "",
          showOkBtn: false,
          showCancelBtn: false,
          showCloseBtn: true        
 }